import * as CustomfieldTypes from "../types/customfield.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";

export const loadCustomfields = (filter: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: CustomfieldTypes.LOADING_CUSTOMFIELD });

  axiosInstance
    .get("/employeeinfo/", { params: { ...filter } })
    .then((res) => {
      dispatch({
        type: CustomfieldTypes.LOAD_CUSTOMFIELD,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.message) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.message,
        });
        dispatch(alertActions.error(err.message));
      } else if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const trashCustomfield =
  (id: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    axiosInstance
      .delete("/employeeinfo/" + id)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Delete success."));

        dispatch(loadCustomfields(filterData));
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, "Delete customfield failed"));
      });
  };

export const blukTrashCustomfield =
  (id: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    axiosInstance
      .delete("/employeeinfo/", id)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Delete success."));

        dispatch(loadCustomfields(filterData));
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, "Delete customfield failed"));
      });
  };

export const saveCustomfield =
  (userData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CustomfieldTypes.CUSTOMFIELD_SAVE_REQUEST });

    axiosInstance
      .post("employeeinfo/", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Company Created Successfully"));
        dispatch({ type: CustomfieldTypes.CUSTOMFIELD_SAVE_SUCCESS });
        dispatch(loadCustomfields(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const getCustomfield = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: CustomfieldTypes.FETCH_CUSTOMFIELD_REQUEST });

  axiosInstance
    .get("employeeinfo/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: CustomfieldTypes.FETCH_CUSTOMFIELD_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const updateCustomfield =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CustomfieldTypes.CUSTOMFIELD_SAVE_REQUEST });

    axiosInstance
      .put("employeeinfo/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: CustomfieldTypes.CUSTOMFIELD_SAVE_SUCCESS });
        dispatch(alertActions.success("CUSTOMFIELD Updated Successfully"));
        dispatch(loadCustomfields(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const searchCustomfields = (filter: string) => {
  return axiosInstance
    .get("/employeeinfo/?q=" + filter)
    .then((res) => {
      return res.data.results;
    })
    .catch((err) => {
      return err;
    });
};

export const updateCustomfieldStatus =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CustomfieldTypes.CUSTOMFIELD_SAVE_REQUEST });

    axiosInstance
      .put("employeeinfo/status/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: CustomfieldTypes.CUSTOMFIELD_SAVE_SUCCESS });
        dispatch(alertActions.success("Customfield Updated Successfully"));
        dispatch(loadCustomfields(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };
